
export class BuildInfo {
  static getBuildInfo(): any {
    return {
      versionTag: '20.0.1-77.0',
      buildNumber: '77',
      buildDate: 'Thu Feb 12 19:57:28 CST 2026',
      buildBranch: 'release',
    };
  }
}
